const whatsText = encodeURIComponent("*Hola!* Necesito ayuda con mi cuenta, no puedo iniciar sesión #HELP");
const whatsTextHelp = encodeURIComponent("*Hola!* Necesito ayuda #HELP");
const whatsappLink = `https://wa.me/+13022615750?text=${whatsText}`;
const unexpectedMsg =  `https://wa.me/+13022615750?text=${whatsTextHelp}`;
export const AUTH_ERRORS = {
    messages: {
        'invalid_grant': `Correo o contraseña incorrectos.<br> <strong>¿Necesitas ayuda para entrar? Prueba a restablecer tu contraseña.</strong>`,
        'Fields required': 'Debe llenar todos los campos correctamente.',
        'Email not verified': 'El correo "{{email}}" no ha sido verificado.',
        'Too many attempts': 'Demasiados intentos fallidos. Inténtelo en {{seconds}} segundos.',
        'Account linked to provider': 'Ya existe una cuenta vinculada a este correo a través de <strong>{{providerName}}</strong>.<br> Intenta iniciar sesión con el botón de {{providerName}}.',
        'account_exists': 'Ya existe una cuenta asociada a este {{userInputType}}.',
        "100": `Lo sentimos, ocurrió un error inesperado. <br> Si el problema persiste <a href="${unexpectedMsg}" target="_blank"> comuníquese con un asesor >></a>`,
        "101": `Parece que faltan algunos datos. <br> <strong>Por favor, revisa los campos requeridos para continuar.</strong>`,
        "102": "Usuario deshabilitado",
        "103": "No se encontró cuenta asociada a este {{userInputType}}. <br> Verifica los datos ingresados e inténtalo de nuevo.",
        "104": "La contraseña que proporcionó es incorrecta. Por favor, vuelva a intentarlo.",
        "105": "Token inválido o mal formado",
        "106": "Cliente no autorizado para esta operación",
        "107": "Cliente no encontrado o deshabilitado",
        "108": "Acceso no permitido a este recurso",
        "109": "Se requiere consentimiento del usuario",
        "110": "Tipo de token no soportado",
        "111": "Proveedor de identidad no permitido",
        "112": "Usuario bloqueado por protección de fuerza bruta",
        "113": "Error de validación externa",
        "114": "Error de configuración de proveedor",
        "115": "Sesión inválida o no encontrada",
        "116": `El código de verificación ingresado no es válido o ha expirado. <br> <strong>Solicita uno nuevo para continuar.</strong>`,
        "117": "OTP ya verificado previamente",
        "118": "CAPTCHA inválido o mal formado",
        "119": "Token inválido o expirado en recuperación",
        "120": `No se pudo completar el cambio de contraseña.<br> <strong> Compruebe que haya ingresado bien los campos. </strong>`,
        "121": "Contraseña no cumple requisitos mínimos",
        "122": "Recuperación no iniciada",
        "123": "Error al actualizar el correo electrónico",
        "124": "Esta cuenta ya fue verificada previamente.",
        "125": "Proceso de cambio de email no iniciado",
        "126": "Código de verificación inválido para cambio de email",
        "127": "Usuario no autenticado (Bearer inválido)",
        "128": "Cliente no es el dueño del token",
        "129": "Error al generar token SAML",
        "130": "Has alcanzado el límite de envío de códigos, por favor intenta más tarde", //Esperar 5min
        "131": "Por motivos de seguridad, debes esperar un momento antes de volver a solicitar un código de verificación.", //Esperar 60
        "132": `Parece que hubo un problema con tu cuenta. <br> Por favor, <a href="${whatsappLink}" target="_blank"> contacta a un asesor</a> para ayudarte`,
        "133": "Ya existe una cuenta asociada a este correo, por favor inicie sesión",
        "134": `Debe confirmar su cuenta para poder realizar esta acción. <br> Por favor <a href="https://edutin.com/helps/requests" target="_blank"> comuniquese con un asesor >></a>`,        

        'Default': `Lo sentimos, ocurrió un error inesperado. <br> Si el problema persiste <a href="${unexpectedMsg}" target="_blank"> comuníquese con un asesor >></a>`,
    } as Record<string, string>,

    /**
     * Función para obtener el mensaje de error con valores dinámicos.
     * @param key Clave del error (por ejemplo, 'User not found')
     * @param params Objeto con los valores dinámicos { email: 'test@mail.com' }
     * @returns Mensaje con valores reemplazados
     */
    getMessage(key: string, params: Record<string, string | number> = {}): string {
        const messages = this.messages as Record<string, string>;
        let message = messages[key] || messages['Default'];

        Object.keys(params).forEach(param => {
            message = message.replace(`{{${param}}}`, String(params[param]));
        });

        return message;
    }
};



// {
//     "100": "Error interno",
//     "101": "Parámetros insuficientes o incorrectos",
//     "102": "Usuario deshabilitado",
//     "103": "Usuario no existe",
//     "104": "Contraseña incorrecta",
//     "105": "Token inválido o mal formado",
//     "106": "Cliente no autorizado para esta operación",
//     "107": "Cliente no encontrado o deshabilitado",
//     "108": "Acceso no permitido a este recurso",
//     "109": "Se requiere consentimiento del usuario",
//     "110": "Tipo de token no soportado",
//     "111": "Proveedor de identidad no permitido",
//     "112": "Usuario bloqueado por protección de fuerza bruta",
//     "113": "Error de validación externa",
//     "114": "Error de configuración de proveedor",
//     "115": "Sesión inválida o no encontrada",
//     "116": "Código OTP expirado",
//     "117": "OTP ya verificado previamente",
//     "118": "CAPTCHA inválido o mal formado",
//     "119": "Token inválido o expirado en recuperación",
//     "120": "Error al cambiar la contraseña",
//     "121": "Contraseña no cumple requisitos mínimos",
//     "122": "Recuperación no iniciada",
//     "123": "Error al actualizar el correo electrónico",
//     "124": "Email ya verificado previamente",
//     "125": "Proceso de cambio de email no iniciado",
//     "126": "Código OTP inválido para cambio de email",
//     "127": "Usuario no autenticado (Bearer inválido)",
//     "128": "Cliente no es el dueño del token",
//     "129": "Error al generar token SAML",
//     "130": "Has alcanzado el límite de envio de mensajes, por favor intenta más tarde",
//     "131": "Error al enviar el mensaje, por favor intenta más tarde",
//     "132": "Usario deshabilitado, porfavor contacte con soporte",
//     "133": "Ya existe una cuenta asociada a este correo, porfavor inicie sesión",
//     "134": "Usuario aun no activa su cuenta",
//     "default": "Error desconocido"
//   }